import { render, staticRenderFns } from "./VideoCourses.vue?vue&type=template&id=165baf84&scoped=true"
import script from "./VideoCourses.vue?vue&type=script&lang=js"
export * from "./VideoCourses.vue?vue&type=script&lang=js"
import style0 from "./VideoCourses.vue?vue&type=style&index=0&id=165baf84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165baf84",
  null
  
)

export default component.exports